"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAnyVal = exports.getCircularReplacer = exports.getScreenRatio = exports.toQueryString = exports.setURLParams = exports.getURLParams = void 0;
var urlParamsMap = new Map();
function getURLParams(url) {
    if (!url) {
        return {};
    }
    if (urlParamsMap.has(url)) {
        return urlParamsMap.get(url);
    }
    var result = {};
    location.search.replace(/([^?&=]+)=([^&]+)/g, function (_, k, v) { return result[k] = v; });
    urlParamsMap.set(url, result);
    return result;
}
exports.getURLParams = getURLParams;
function setURLParams(url, params) {
    if (!params || typeof params !== 'object' || Object.keys(params).length === 0) {
        return url;
    }
    var args = __assign(__assign({}, getURLParams(url)), params);
    return url.split('?')[0] + "?" + toQueryString(args);
}
exports.setURLParams = setURLParams;
function toQueryString(obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj)
        .filter(function (v) { return !/undefined|null/.test(String(obj[v])); })
        .map(function (v) { return v + "=" + encodeURIComponent(obj[v]); })
        .join('&');
}
exports.toQueryString = toQueryString;
function getScreenRatio() {
    var width = window.document.body.offsetWidth;
    var height = window.document.body.offsetHeight;
    return Number((width / height).toFixed(1));
}
exports.getScreenRatio = getScreenRatio;
var getCircularReplacer = function () {
    var seen = new WeakSet();
    return function (key, value) {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
exports.getCircularReplacer = getCircularReplacer;
var formatAnyVal = function (value) {
    if (typeof value === 'string')
        return value;
    if (value instanceof Error) {
        var _a = value, message = _a.message, stack = _a.stack;
        return (stack === null || stack === void 0 ? void 0 : stack.includes(message)) ? stack : value.name + ": " + message + " \n " + stack;
    }
    if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
        return JSON.stringify(value, exports.getCircularReplacer());
    }
    return value;
};
exports.formatAnyVal = formatAnyVal;
//# sourceMappingURL=browser.util.js.map